/**
 * Centralized route path constants.
 * Use these instead of hardcoded strings in Link/navigate/useLocation comparisons.
 */
export const ROUTES = {
  LANDING: '/',
  COMPLIANCE: '/compliance',
  ADD_TO_LIBRARY: '/add/:bookId',
  LOGIN: '/login',
  DISTRICT_SIGNUP: '/district-signup',
  AUTH_CALLBACK: '/auth/callback',

  HOME: '/home',
  MY_LIBRARY: '/my-library',
  NOW_PLAYING: '/now-playing',
  READINGS_DESIGNER: '/readings-designer',
  SETTINGS: '/settings',
  ABOUT: '/about',
  ACCESSIBILITY: '/accessibility',
};
